// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "patient_id":'',
    "user_name":'',
    "user_name_domain": '',
    "patient_name":'',
    "device_id":'',
    "reading_details":'',
    "reading_details_inverse":'',
    "device_id_inverse":'',
    "patient_name_inverse": '',
    "patient_id_inverse":'',
    "user_name_inverse":'',
    "match": false,
    "DashboardSearchApplied": false,
};

const dashboardSearchSlice = createSlice({
    name: 'AlertNotificationSearch',
    initialState,
    reducers: {
        setDashboardSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetDashboardSearch(state) {
            return { ...initialState, DashboardSearchApplied: false }; // Reset state and flag
        },
        setDashboardSearchApplied(state) {
            state.DashboardSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setDashboardSearch, 
    resetDashboardSearch, 
    setDashboardSearchApplied } = dashboardSearchSlice.actions;

export default dashboardSearchSlice.reducer;